import axiosInstance from "../axiosInterceptor";

export async function getTestimonial() {
    const response = await axiosInstance.get(`admin/testimonial/getAllTestimonial`);
    const data = response?.data;
    return data;
}
